/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable */
import { useEffect, useState, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Switch, Menu, MenuItem } from '@mui/material';
import { formActions } from '@/Actions';
// import ListTable from '../../../Components/ListTable/ListTable';
import moment from 'moment';
import { downloadCSV, handleResponseStreamDownload, inputHelper } from '../../../Helpers';
import VirtualizedListTable from '../../../Components/VirtualizedListTable/VirtualizedListTable';
import { notificationServices } from '@/Services';
import allProductServices from '@/Services/Form Services/allproduct.services';
import storeServices from '@/Services/Form Services/store.services';
import reportsService from '@/Services/ReportsServices/reports.service';
import { useAuth } from '@/Components/Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import excel from '../../../Images/excel.svg';

const TABLE_COLUMNS = [
	{
		title: 'UY Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Inventory Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Purchase Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Brand',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Veg',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Third Party Sales',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Enabled',
		config: {
			type: 'UPDATE',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Delete',
		config: {
			type: 'DELETE',
		},
	},
];

const COLMAP = {
	'UY Id': 'id',
	Name: 'productName',
	'Inventory Unit': 'unit',
	'Purchase Unit': 'purchaseUnit',
	Brand: 'brandName',
	'SKU Type': 'skuType',
	'Category Name': 'categoryName',
	'Sub Category': 'subCategoryName',
	Veg: 'isVeg',
	Enabled: 'isEnabled',
};
const AllProductListPage = (props) => {
	const {
		fetchProducts,
		toggleDisableProduct,
		data,
		listPageProps,
		query,
		deleteProduct,
		searchBy,
		userPermissions,
		navState,
		userList,
		fetchUserList,
	} = props;
	const { userConfig } = useAuth();

	// Anchor element for the export dropdown menu
	const [exportMenuAnchor, setExportMenuAnchor] = useState(null);
	const exportMenuOpen = Boolean(exportMenuAnchor);
	const handleDelete = ({ id }) => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Deleting product...',
		});
		deleteProduct({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id,
				},
			},
			method: 'DELETE',
			promisify: true,
		})
			.then((res) => {
				notificationServices.generateNotification({
					type: 'success',
					message:
						res?.message
						|| res?.responseMessage
						|| 'Product deleted successfully',
					config: { id: notificationId },
				});
			})
			.catch((err) => {
				notificationServices.generateNotification({
					type: 'error',
					message:
						err || err?.message
						|| err?.responseMessage
						|| 'Failed to delete product',
					config: { id: notificationId },
				});
			});
	};

	const handleEnable = (e) => {
		const { fieldValue, dataset } = inputHelper(e);
		toggleDisableProduct({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id: dataset.id,
				},
				data: {
					isEnabled: fieldValue,
				},
			},
			method: 'PATCH',
		});
	};

	const SPECIAL_ITEMS = {
		Veg: (id, isVeg) => {
			return (
				<div
					className={`dot-container small ${isVeg ? 'veg' : 'non-veg'
						}`}
				>
					<div className='dot' />
				</div>
			);
		},
		Enabled: (id, isEnabled) => {
			return (
				<Switch
					name='enabled'
					value='isEnabled'
					size='small'
					color='primary'
					onChange={handleEnable}
					defaultChecked={isEnabled}
					inputProps={{
						'data-id': id,
						'data-type': 'ALL_PRODUCTS',
					}}
				/>
			);
		},
	};
	// Build a CSV string from the Variantwise Item Master report payload
	// ({ headers, rowData }), matching the inventory-reports viewer export.
	const buildReportCsv = (reportData) => {
		const escapeCsv = (value) =>
			`"${(value ?? '-').toString().replace(/"/g, '""')}"`;
		const headerNames = [];
		const headerKeys = [];
		(reportData?.headers ?? []).forEach((header) => {
			if (header?.keys?.length > 0) {
				header.keys.forEach((subHeader) => {
					headerNames.push(
						`${header?.displayName}-${subHeader?.displayName}`
					);
					headerKeys.push(subHeader?.key);
				});
			} else {
				headerNames.push(header?.displayName);
				headerKeys.push(header?.key);
			}
		});
		const lines = [headerNames.map(escapeCsv).join(',')];
		(reportData?.rowData ?? []).forEach((obj) => {
			lines.push(
				headerKeys.map((key) => escapeCsv(obj?.row?.[key])).join(',')
			);
		});
		return lines.join('\n');
	};

	const handleExport = async () => {
		setExportMenuAnchor(null);
		try {
			// Variantwise Item Master (report 13) is scoped to a base kitchen +
			// date; use the first available base kitchen and today's date.
			const storesRes = await storeServices.gateway({
				req: { params: { id: '', type: 'BASE' } },
				method: 'LIST',
			});
			const baseKitchen = storesRes?.data?.[0];
			if (!baseKitchen?.id) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'No base kitchen found to export item master',
				});
				return;
			}
			const reportRes = await reportsService.getReportData({
				urlPath: [13],
				data: {
					filter: {
						storeFilter: [baseKitchen.id],
						dateOnly: moment().format('YYYY-MM-DD'),
					},
				},
			});
			if (
				reportRes?.responseCode === 'SS-001' ||
				reportRes?.statusCode === 200
			) {
				downloadCSV(
					buildReportCsv(reportRes?.data),
					'Variantwise_Item_Master.csv'
				);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occurred',
			});
		}
	};

	useEffect(() => {
		fetchProducts({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id: '',
					// skuType: 'PRODUCT',
					skuType: '',
					combo: false,
					variants: true,
				},
			},
			method: 'LIST',
			showNotification: true,
		});
	}, []);

	/**
	 * Build a lookup map: variantId -> variant details.
	 * The raw LIST data stores accompaniments as {id: variantId, qty} so we
	 * use this map to resolve product name, variant name and SKU code when
	 * exporting. Rebuilt only when the loaded products list changes.
	 */
	const variantLookupMap = useMemo(() => {
		const map = {};
		(data ?? []).forEach((product) => {
			(product?.variants ?? []).forEach((variant) => {
				if (variant?.id != null) {
					map[variant.id] = {
						clientVariantId: variant.clientVariantId,
						displayName: variant.displayName ?? variant.variantName,
						productName: product.productName,
					};
				}
			});
		});
		return map;
	}, [data]);

	/**
	 * Build and download a CSV of accompaniments data.
	 * Uses variantLookupMap to resolve acc product name and
	 * SKU code from the raw {id, qty} stored in the API list response.
	 * Product-level accompaniments apply to every variant of the product,
	 * so they are expanded into one row per product variant.
	 *
	 * Columns: Product Name | SKU Type | Category | Level |
	 *          Product Variant Name | SKU code |
	 *          Accompaniment Product Name |
	 *          Accompaniment Variant ID | Accompaniment SKU Code | Qty
	 */
	const handleAccompanimentsExport = useCallback(() => {
		setExportMenuAnchor(null);

		const headers = [
			'Product Name',
			'SKU Type',
			'Category',
			'Level',
			'Product Variant Name',
			'SKU code',
			'Accompaniment Product Name',
			'Accompaniment Variant ID',
			'Accompaniment SKU Code',
			'Qty',
		];

		const escapeCsv = (value) =>
			`"${(value ?? '-').toString().replace(/"/g, '""')}"`;

		const rows = [];

		(data ?? []).forEach((product) => {
			// ── Product-level accompaniments ──────────────────────────────────
			// Raw format from API: product.accompaniments = [{id: variantId, qty}]
			// Applies to the product as a whole, so emit one row per product
			// variant (falling back to a single '-' row if there are none).
			const productAccompaniments = product?.accompaniments ?? [];
			if (productAccompaniments.length > 0) {
				const productVariants = product?.variants ?? [];
				const variantRows = productVariants.length > 0
					? productVariants
					: [null];

				productAccompaniments.forEach((acc) => {
					// acc.id is the accompaniment variant's ID
					const accInfo = variantLookupMap[acc?.id];
					variantRows.forEach((variant) => {
						rows.push([
							escapeCsv(product?.productName),
							escapeCsv(product?.skuType),
							escapeCsv(product?.categoryName),
							escapeCsv('Product'),
							escapeCsv(variant?.displayName ?? variant?.variantName ?? '-'),
							escapeCsv(variant?.clientVariantId ?? '-'),
							escapeCsv(accInfo?.productName),
							escapeCsv(acc?.id),
							escapeCsv(accInfo?.clientVariantId),
							escapeCsv(acc?.qty),
						].join(','));
					});
				});
			}

			// ── Variant-level accompaniments ──────────────────────────────────
			// Raw format from API: variant.accompaniments = [{id: variantId, qty}]
			(product?.variants ?? []).forEach((variant) => {
				const variantAccompaniments = variant?.accompaniments ?? [];
				if (variantAccompaniments.length > 0) {
					variantAccompaniments.forEach((acc) => {
						const accInfo = variantLookupMap[acc?.id];
						rows.push([
							escapeCsv(product?.productName),
							escapeCsv(product?.skuType),
							escapeCsv(product?.categoryName),
							escapeCsv('Variant'),
							escapeCsv(variant?.displayName ?? variant?.variantName),
							escapeCsv(variant?.clientVariantId),
							escapeCsv(accInfo?.productName),
							escapeCsv(acc?.id),
							escapeCsv(accInfo?.clientVariantId),
							escapeCsv(acc?.qty),
						].join(','));
					});
				}
			});
		});

		if (rows.length === 0) {
			notificationServices.generateNotification({
				type: 'info',
				message: 'No accompaniments data found for the loaded products.',
			});
			return;
		}

		const csvContent = [headers.map(escapeCsv).join(','), ...rows].join('\n');
		downloadCSV(csvContent, `Accompaniments_Data_${moment().format('YYYY-MM-DD')}.csv`);
	}, [data, variantLookupMap]);

	const genrateData = () => {
		return data?.filter((product) => {
			if (searchBy?.get === 'clientVariantId') {
				if (!query?.trim()) {
					return true;
				}
				return product?.variants?.some((variant) => {
					return (
						variant?.clientVariantId?.toLowerCase().trim().includes(
						query?.toLowerCase().trim())
					);
				});
			}
			return (
				product?.[searchBy?.get]
					?.toLowerCase()
					?.indexOf(query?.trim()?.toLowerCase()) !== -1
			);
		})
			.map((product) => {
				return {
					...product,
					_name: product?.[COLMAP?.Name],
					deleteMessage: `The associated recipe of ${product?.[COLMAP?.Name]} will also be deleted`
				};
			});
	};

	/**
	 * Single EXPORT button that opens a MUI Menu with two export options:
	 *   1. Products (Item Data)  — existing Variantwise Item Master report
	 *   2. Accompaniments        — new accompaniments CSV
	 * Passed via renderBtns; default VirtualizedListTable export is hidden
	 * by allowExport={false}.
	 */
	const renderExportMenu = () => (
		<>
			<div
				onClick={(e) => setExportMenuAnchor(e.currentTarget)}
				style={{
					width: '125px',
					textAlign: 'center',
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '0.25rem',
					zIndex: 10,
					backgroundColor: '#1d6f42',
					color: 'white',
					borderRadius: '1rem',
					padding: '0.25rem 0.5rem',
					userSelect: 'none',
				}}
				title='Export data'
			>
				<img src={excel} alt='excel' style={{ width: '25px' }} />
				EXPORT
			</div>

			<Menu
				anchorEl={exportMenuAnchor}
				open={exportMenuOpen}
				onClose={() => setExportMenuAnchor(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				PaperProps={{
					elevation: 3,
					sx: { minWidth: 230, borderRadius: '8px', mt: 0.5 },
				}}
			>
				<MenuItem
					onClick={handleExport}
					sx={{ fontSize: '0.875rem', gap: 1 }}
				>
					<img src={excel} alt='excel' style={{ width: '20px', opacity: 0.8 }} />
					Products (Item Data)
				</MenuItem>
				<MenuItem
					onClick={handleAccompanimentsExport}
					sx={{ fontSize: '0.875rem', gap: 1 }}
				>
					<img src={excel} alt='excel' style={{ width: '20px', opacity: 0.8 }} />
					Accompaniments
				</MenuItem>
			</Menu>
		</>
	);

	return (
		<VirtualizedListTable
			colMap={COLMAP}
			columns={TABLE_COLUMNS}
			importState={{
				show: false,
			}}
			fixedHeaderTop={0}
			data={genrateData()}
			actions={[...SPECIAL_COLUMNS, ...ACTION_COLUMNS]}
			special={SPECIAL_ITEMS}
			handleDelete={handleDelete}
			allowExport={false}
			renderBtns={renderExportMenu}
		/>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.ALL_PRODUCTS.data.LIST;
	const { userPermissions, navState } = state.navigation;
	const { userList } = state.auth;
	return {
		data,
		userPermissions,
		navState,
		userList,
	};
};

const mapDispatchToProps = {
	fetchProducts: formActions.gateway,
	toggleDisableProduct: formActions.gateway,
	deleteProduct: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllProductListPage);
